import React, { useMemo } from 'react';
import { AlertContext, AlertContextProps, alertSlice } from '../context/AlertContext';
import { Alert } from '../types/alert';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface AlertProviderProps {
  children: React.ReactNode;
}

export default function AlertProvider({ children }: AlertProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.alerts.items);
  const loading = useAppSelector(state => state.alerts.loading);

  const alerts = useMemo(() => {
    return new Map(items.map(item => [item.id, new Alert(item)]));
  }, [items]);

  const alertContext: AlertContextProps = {
    alerts,
    alertsLoading: loading,
    setAlerts: (alerts: Map<string, Alert>) => dispatch(alertSlice.actions.set([...alerts.values()])),
  };

  return <AlertContext.Provider value={alertContext}>{children}</AlertContext.Provider>;
}
